import { Modal } from 'antd';
import './style.scss';
import CustomButton from '../../../../../../../../v2-components/Antd/Button';
import { pharmacyFeatures } from '../../../../../../../../v2-config/constants/pharmacy-features.constant';
import { ENV_COUNTRY } from '../../../../../../../../components/Commons/Hooks/Variables/Enviroment';
import { getDeliveryTypeLegend } from './legends.constant';

const DeliveryModal = ({ visible, onCancel, onAccept, deliveryType }) => {
	const legend = getDeliveryTypeLegend(ENV_COUNTRY, deliveryType);

	const getModalContent = () => {
		if (!legend) return null;

		return (
			<div>
				<h3>{legend.heading}</h3>
				<ul>
					{legend.bullets.map((bullet) => (
						<li key={bullet}>{bullet}</li>
					))}
					{deliveryType === 'pharmacy' && pharmacyFeatures.pickupWhatsAppNotification && (
						<li>Se notificará por WhatsApp cuando esté disponible para retiro.</li>
					)}
				</ul>
			</div>
		);
	};

	const title = deliveryType === 'pharmacy' ? 'Retiro en farmacia' : 'Envío a domicilio';

	return (
		<Modal
			title={title}
			visible={visible}
			onCancel={onCancel}
			footer={[
				<CustomButton key="accept" className="ph-btn ph-btn--accept" onClick={onAccept}>
					Aceptar
				</CustomButton>,
			]}
			className="delivery-modal"
		>
			{getModalContent()}
		</Modal>
	);
};

export default DeliveryModal;
